import React from "react";

export const renderLander = () => {
    return (
        <div className="lander">
            <h1>Mis Servicios Escolares</h1>
            <p>Servicios escolares</p>
        </div>
    );
};